export const MOVIE_TYPES = [
  { value: 'all', label: 'All' },
  { value: 'movie', label: 'Movie' },
  { value: 'series', label: 'Series' },
  { value: 'game', label: 'Game' },
];